export const isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;

export function checkIsMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
}
